// src/store/slices/coursesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ApiService from '../../services/ApiService';

export const fetchAllCourses = createAsyncThunk('courses/fetchAllCourses', async (_, { rejectWithValue }) => {
    try {
        const response = await ApiService.publicGetRequest('/courses/findallcourses');
        return response.data.data; // Assuming response.data.data contains the courses
    } catch (error) {
        return rejectWithValue('Error fetching courses');
    }
});



const coursesSlice = createSlice({
    name: 'courses',
    initialState: {
        courses: [],
        status: 'idle',
        errors: null,
        loaderStatus: true,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllCourses.pending, (state) => {
                state.loaderStatus = true;
            })
            .addCase(fetchAllCourses.fulfilled, (state, action) => {
                state.loaderStatus = false;
                state.courses = action.payload;
            })
            .addCase(fetchAllCourses.rejected, (state, action) => {
                state.loaderStatus = false;
                state.errors = action.payload;
            });
    },
});

export default coursesSlice.reducer;
